import { useAsObservableSource, useLocalStore } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { Features } from 'APP/packages/features/Features';

interface IDraftInputPresenter {
  updateTimeout: ReturnType<typeof setTimeout> | null;
  value: string;
  update(value: string): void;
  reset(): void;
}

const UPDATE_TIMEOUT = 3000;

export const useDraftInput = (groupId: string): IDraftInputPresenter => {
  const source = useAsObservableSource({ groupId });

  const presenter = useLocalStore<IDraftInputPresenter>(() => ({
    updateTimeout: null,
    value: '',

    update(value: string): void {
      if (!Features.isDraftInputEnabled()) {
        return;
      }

      presenter.reset();
      presenter.value = value;
      presenter.updateTimeout = setTimeout(() => {
        Tasks.group.updateDraftInput(source.groupId, presenter.value);
      }, UPDATE_TIMEOUT);
    },

    reset(): void {
      if (presenter.updateTimeout) {
        clearTimeout(presenter.updateTimeout);
      }
    },
  }));

  useEffect(() => {
    if (!Features.isDraftInputEnabled()) {
      return;
    }

    const prevGroupId = groupId;
    return () => {
      presenter.reset();
      Tasks.group.updateDraftInput(prevGroupId, presenter.value);
      presenter.value = '';
    };
  }, [groupId]);

  return presenter;
};
